import { atom } from 'recoil';

// 좌측 사이드바 접힘 상태 (헤더 햄버거 + 사이드바 핸들이 공유)
export const sidebarCollapsedAtom = atom({
  key: 'sidebarCollapsedAtom',
  default: false,
});
